import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#045ae3",
        secondary: "#03a9f4",
        accent: "#3f51b5",
        error: "#f44336",
        warning: "#ffc107",
        info: "#00bcd4",
        success: "#4caf50"
      }
    }
  },
  icons: {
    iconfont: "fa"
  }
};

export default new Vuetify(opts);
